export const isSandboxUrl = () =>
  window.location.host.toUpperCase().includes('SANDBOX');

// export const isSandboxUrl = () => true;
